/**
 * 每个菜单代码对应的VUE组件
 * Created by xingxiaowen on 2018/09/03
 * @type {{}}
 */

import Layout from '@/views/layout/Layout'
import pmsLayout from '@/views/pms/index'

const compMap = {

  /**
   * 充值
   */
  'recharge': Layout,
  // 快速充值
  'quickRecharge': () => import('@/views/recharge/quickRecharge/index'),
  // 费用充抵
  'costNetting': () => import('@/views/recharge/costNetting/index'),

  /**
   * 运行监测 只有一级菜单
   */
  'runMonitor': {
    'root': Layout,
    'children': [
      {
        'path': 'index',
        component: () => import('@/views/runMonitor/index')
      }
    ]
  },

  /**
   * 数据查询
   */
  'dataQuery': Layout,
  // 能耗查询
  'energyDataQuery': () => import('@/views/dataQuery/energyDataQuery/index'),
  // 充值明细查询
  'rechargeDetailQuery': () => import('@/views/dataQuery/rechargeDetailQuery/index'),

  /**
   * 统计报表
   */
  'statisticReport': Layout,
  // 充值统计报表
  'rechargeReport': () => import('@/views/statisticReport/rechargeReport/index'),
  // 综合统计报表
  'syntheticReport': () => import('@/views/statisticReport/syntheticReport/index'),

  /**
   * 报警记录，只有一级菜单
   */
  'alarmRecord': {
    root: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/alarmRecord/index')
      }
    ]
  },

  /**
   * 能耗分析 只有一级菜单
   */
  'energyAnalysis': {
    root: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/energyAnalysis/index')
      }
    ]
  },

  /**
   * 运行管理
   */
  'runManage': Layout,
  /**
   * 日志管理
   * @returns {Promise<*>|*}
   */
  'logManage': () => import('@/views/runManage/logManage/index'),
  /**
   * 通知管理
   */
  'noticeManage': () => import('@/views/runManage/noticeManage/index'),
  /**
   * 短信明细管理
   */
  'smsDetailsManage': () => import('@/views/runManage/smsDetailsManage/index'),
  /**
   * 短信缴费
   */
  'smsPrepaidRecord': () => import('@/views/runManage/smsPrepaidRecord/index'),
  /**
   * 工程配置
   */
  'pms': Layout,
  /**
   * 权限管理
   */
  'authManage': pmsLayout,
  'roleManage': () => import('@/views/pms/authManage/roleManage/index'),
  'userManage': () => import('@/views/pms/authManage/userManage/index'),

  /**
   * 测量设备管理
   */
  'measureDeviceManage': pmsLayout,
  'collectionManage': () => import('@/views/pms/measureDeviceManage/collectionManage/index'),
  'meterManage': () => import('@/views/pms/measureDeviceManage/meterManage/index'),

  /**
   * 能耗单元配置
   */
  'energyUnit': pmsLayout,
  'approachConfig': () => import('@/views/pms/energyUnit/approachConfig/index'),
  'energyUnitConfig': () => import('@/views/pms/energyUnit/energyUnitConfig/index'),
  'energyUnitFormula': () => import('@/views/pms/energyUnit/energyUnitFormula/index'),

  /**
   * 业主用户仪表配置
   */
  'tenantMeterConfig': pmsLayout,
  'tenantManage': () => import('@/views/pms/tenantMeterConfig/tenantManage/index'),
  'meterConfigAccount': () => import('@/views/pms/tenantMeterConfig/meterConfigAccount/index'),
  'meterBatchRecharge': () => import('@/views/pms/tenantMeterConfig/meterBatchRecharge/index'),
  /**
   * 基础数据设置
   */
  'basicDataManage': pmsLayout,
  'customerInfo': () => import('@/views/pms/basicDataManage/customerInfo/index'),
  'energyDataType': () => import('@/views/pms/basicDataManage/energyDataType/index'),
  'chargingConfig': () => import('@/views/pms/basicDataManage/chargingConfig/index'),
  'pushDataSetting': () => import('@/views/pms/basicDataManage/pushDataSetting/index'),
  'rechargeResultPush': () => import('@/views/pms/basicDataManage/rechargeResultPush/index'),
  'secretKeyConfig': () => import('@/views/pms/basicDataManage/secretKeyConfig/index'),
  /**
  *系统设置
 */
  'systemConfig': pmsLayout,
  'meterType' : () => import('@/views/pms/systemConfig/meterType/index'),
  /**
   * 查询机：余额查询
   */
  'iQueryBalance': {
    root: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/inquiryMachine/queryBalance/index')
      }
    ]
  },
  /**
   * 查询机：自助充值
   */
  'iPay': {
    root: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/inquiryMachine/recharge/index')
      }
    ]
  },
  /**
   * 查询机：充值明细
   */
  'iRechargeDetailQuery': {
    root: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/inquiryMachine/rechargeDetailQuery/index')
      }
    ]
  },
  /**
   * 查询机：数据查询
   */
  'iEnergyDataQuery': {
    root: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/inquiryMachine/energyDataQuery/index')
      }
    ]
  },
  /**
   * 查询机：使用帮助
   */
  'iUseHelp': {
    root: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/inquiryMachine/useHelp/index')
      }
    ]
  },

  /**
   * 查询机：使用帮助
   */
  'iEnergyAnalysis': {
    root: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/inquiryMachine/energyAnalysis/index')
      }
    ]
  }

}

export default compMap
